import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t;

import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardSection from 'UIComponents/card/UICardSection';
import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIIcon from 'UIComponents/icon/UIIcon';
import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { ProductLineToColor } from '../../constants/whyGoHubSpotSection/ProductLineToColor';
import { borderStyle } from '../free-tools-page/FreeToolsSharedComponents';
import breakpoint from '../../constants/Breakpoints';
import { usePageParams } from '../../hooks/usePageParams';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { WHY_GO_HUBSPOT_CARD } from '../../constants/tracking/Locations';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
const HeaderSection = styled.div.withConfig({
  displayName: "MobileProductLineTile__HeaderSection",
  componentId: "ucr1vu-0"
})(["background-color:", " !important;padding:14px 0;", ""], ({
  productLine
}) => ProductLineToColor[productLine], breakpoint.tabletPortrait(_t || (_t = _`
    max-width: 100%;
  `)));
const HeaderTextContainer = styled.span.withConfig({
  displayName: "MobileProductLineTile__HeaderTextContainer",
  componentId: "ucr1vu-1"
})(["font-size:24px;color:", ";"], OLAF);
const PrimaryTextContainer = styled.div.withConfig({
  displayName: "MobileProductLineTile__PrimaryTextContainer",
  componentId: "ucr1vu-2"
})(["font-weight:500;margin-bottom:20px;"]);
const Link = styled(UIRouterLink).withConfig({
  displayName: "MobileProductLineTile__Link",
  componentId: "ucr1vu-3"
})([":hover{text-decoration:none;}"]);
const LinkMessage = styled(FormattedMessage).withConfig({
  displayName: "MobileProductLineTile__LinkMessage",
  componentId: "ucr1vu-4"
})([":hover{text-decoration:underline !important;}"]);
const ProductLineTilesContainer = styled.div.withConfig({
  displayName: "MobileProductLineTile__ProductLineTilesContainer",
  componentId: "ucr1vu-5"
})(["display:block;grid-template-columns:1fr;justify-items:center;margin:0 auto 12px;"]);

const MobileProductLineTile = ({
  productLine,
  commonStyles
}) => {
  const {
    tab
  } = usePageParams();
  const hasTabbedPage = productLine !== COMMERCE;
  const path = `/${productLine.toLowerCase()}${tab && hasTabbedPage ? `/${tab}` : ''}`;

  const trackExploreClick = () => {
    getUsageTracker().track('internalLinkClick', {
      name: 'explore-link',
      url: path,
      trackingSource: WHY_GO_HUBSPOT_CARD
    });
  };

  return /*#__PURE__*/_jsxs(ProductLineTilesContainer, {
    children: [/*#__PURE__*/_jsx(HeaderSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 1
      }),
      productLine: productLine,
      children: /*#__PURE__*/_jsx(HeaderTextContainer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `whyGoHubSpot.${productLine}.title`
        })
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 2,
        paddingTop: '20px'
      }),
      children: /*#__PURE__*/_jsx(PrimaryTextContainer, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `whyGoHubSpot.${productLine}.primary`
        })
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 3
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `whyGoHubSpot.${productLine}.subCopy`
      })
    }), /*#__PURE__*/_jsx(UICardSection, {
      style: Object.assign({}, commonStyles, {
        gridRowStart: 4,
        textAlign: 'left',
        borderBottom: borderStyle
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: createToObject(path),
        onClick: trackExploreClick,
        children: /*#__PURE__*/_jsxs(UIFlex, {
          justify: "center",
          children: [/*#__PURE__*/_jsx(LinkMessage, {
            message: `whyGoHubSpot.${productLine}.explore`
          }), /*#__PURE__*/_jsx(UIIcon, {
            name: "next",
            size: "xs",
            className: "p-left-3 m-right-0"
          })]
        })
      })
    })]
  });
};

export default MobileProductLineTile;